<ion-app>

<ion-menu side="start" menuId="front" contentId="main" class="" id="menuFront" type="overlay">


<!-- ADD NG-STYLE FOR FULL PAGE BACKGROUND --> 
<!--
<ion-content [ngStyle]="{'background-image': 'url(' + graphicBckg + ')','background-size':'cover'}">   
-->
<ion-content> 
     
 
<div class="wrap-app-front">
    
        <div class="event-logo">
            <img src="{{logo}}">
        </div>
        
        <div class="title-subtext" innerHTML="{{dataService.getLangCustom('slogan')}}"></div>
        
     <ion-list>  
      <div *ngFor="let page of pagesFrontMenu">
            <ion-item lines="none" *ngIf="page.path !== 'inappbrowser' && page.path !== 'openprofilebrowser' && page.path !== 'userprofile'" (click)="menuClose('front')" [class.active-page]="checkActive(page)" (click)="openPage(page)" detail="false" class="test">
                 {{page.menuTitle}}
            </ion-item> 
            <ion-item lines="none" *ngIf="page.path === 'inappbrowser' || page.path === 'openprofilebrowser' || page.path === 'userprofile'" (click)="openPage(page)" detail="false">
                 {{page.menuTitle}} <!-- <ion-icon name="{{page.icon}}"></ion-icon>--> 
            </ion-item> 
        </div>
    </ion-list>

    <div class="custom-graphic-addition"><div class="inner-graphics"></div></div>
    
</div>    
    
    <!-- ADD THIS IF NOT FULL PAGE BACKGROUND, change year class each year -->
      
    
      <div class="event-graphics {{graphicClass}}">
        <!-- DONT USE GRAPHIC - USING BCKGRND -->
        
        <img *ngIf="graphicBckg" class="background-img" src="{{graphicBckg}}">
        <img *ngIf="graphic" class="overlay-img" src="{{graphic}}">
        
         
      </div>
   
    
      <!-- GD25 special - full backgound img + bottom img 

    <div class="graphics-wrapper">
        <div class="event-graphics {{graphicClass}}">
            <img *ngIf="graphic" class="overlay-img" src="{{graphic}}">
        </div>
      -->
    
        <!--
        <div class="ocean">
            <div class="wave-static"></div>
        </div>
        
    </div>
    -->
    
  </ion-content>
</ion-menu>
    
    
    
    
    
    
    
    

<ion-menu side="end" menuId="rear" contentId="main" class="" id="menuRear" type="reveal">
 
  <ion-content class="ion-padding-small"  [ngStyle]="{'background-image': 'url(' + graphicBckg2 + ')','background-size':'cover'}">
      
    
        <div class="event-logo rear">
        <img src="{{logoRear}}">
        </div>
        
      <!--
      
        <div *ngIf="socialGroup === 'list'" class="social-links list">
        <button ion-item *ngFor="let page of pagesSocialMenu" (click)="openPage(page)">
            {{page.menuTitle}} <ion-icon item-end name="{{page.icon}}"></ion-icon>
        </button>
        </div>
        
        
        <div *ngIf="socialGroup === 'columns'" class="social-links columns">
            <div class="soc-links-group">
                <div class="social-link" *ngFor="let page of pagesSocialMenu" (click)="openPage(page)">
                    <ion-icon item-end name="{{page.icon}}"></ion-icon>
                </div>
            </div>
            <div class="margin-group"></div>
        </div>

-->
      
      <div *ngIf="socialGroup === 'columns'" class="social-links columns" >
        <ion-chip *ngFor="let page of pagesSocialMenu" (click)="openPage(page)" color="transparent">
          <ion-icon name="{{page.icon}}"></ion-icon>
        </ion-chip>
      </div>
      
        
        
      
     <ion-list>  
      <div *ngFor="let page of pagesRearMenu">
            <ion-item lines="none" *ngIf="page.path !== 'inappbrowser' && page.path !== 'openprofilebrowser' && page.path !== 'userprofile'" (click)="menuClose('rear')" [class.active-page]="checkActive(page)" (click)="openPage(page)" routerDirection="forward" detail="false">
                <ion-label><ion-icon name="{{page.icon}}"></ion-icon> {{page.menuTitle}}</ion-label>
            </ion-item> 
            <ion-item lines="none" *ngIf="page.path === 'inappbrowser' || page.path === 'openprofilebrowser' || page.path === 'userprofile'" (click)="openPage(page)">
                <ion-label ><ion-icon name="{{page.icon}}"></ion-icon> {{page.menuTitle}}</ion-label>
            </ion-item> 
        </div>
        
    </ion-list>
    
      
      
      
      
        
         <div *ngIf="languages.length > 1" class="languages columns">
             <div class="lang-group">
                <ion-item lines="none" *ngFor="let langDict of languages" (click)="changeLang(langDict.lang)" [class.active-lang]="checkActiveLang(langDict.lang)">
                    {{langDict.name}}
                </ion-item>
            </div>
            <div class="margin-group"></div>
       </div>
        
            
        <br>
        <br>
        <ion-item lines="none" class="copyright"><div class="copyright-text" [innerHTML]="copyrightText"></div></ion-item> 
        
        
    
  </ion-content>
</ion-menu>

    
    

    

<ion-router-outlet id="main"></ion-router-outlet>

</ion-app>

